/**
 * Supabase Configuration
 * Centralized configuration for Supabase connection and settings
 */

const config = {
  // Supabase Connection
  supabaseUrl: 'https://eximyshafkuyehkiotuf.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4aW15c2hhZmt1eWVoa2lvdHVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxODc0MDEsImV4cCI6MjA3MDc2MzQwMX0.bjrI5MO_WUfnI53UaQ_m8BS8LPh2et5OrqMKmWUvYzw',
  supabaseServiceKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4aW15c2hhZmt1eWVoa2lvdHVmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NTE4NzQwMSwiZXhwIjoyMDcwNzYzNDAxfQ.iGoZMXdjGdiyThkA1GH0MvJqEiIrYX18Omj7HZDKuXU',
  
  // Environment
  environment: process.env.NODE_ENV || 'development',
  
  // Admin Authentication
  adminEmail: 'admin@myclass.edu.hk',
  adminPassword: 'admin123', // Should be moved to environment variables in production
  
  // Cache Settings
  cache: {
    defaultTTL: 300, // 5 minutes
    maxSize: 100, // Maximum number of cached items
  },
  
  // API Settings
  api: {
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
    retryDelay: 1000, // 1 second
  },
  
  // Security Settings
  security: {
    enableRLS: true,
    requireAuth: true,
    sessionTimeout: 3600, // 1 hour
  }
};

// Environment-specific overrides
if (config.environment === 'production') {
  // Production overrides
  config.supabaseUrl = process.env.REACT_APP_SUPABASE_URL || config.supabaseUrl;
  config.supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || config.supabaseAnonKey;
  config.supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY || config.supabaseServiceKey;
  config.adminEmail = process.env.REACT_APP_ADMIN_EMAIL || config.adminEmail;
  config.adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || config.adminPassword;
}

export default config;
